import type { TDeal } from '../model/deal';

export const getDealInfoText = ({
    objectType,
    area,
    joinSeparator = ' ',
    unit,
}: {
    objectType?: TDeal['objectType'];
    area?: TDeal['area'];
    joinSeparator?: string;
    unit?: TDeal['unit'];
}) => {
    const hasArea = area !== null && area !== undefined && area !== '';
    const numericArea = Number(area);
    const formattedArea = Number.isFinite(numericArea) ? numericArea : area;
    const areaText = hasArea
        ? [formattedArea, unit]
              .filter((value) => value !== null && value !== undefined && value !== '')
              .join('\u00A0')
        : undefined;

    return [objectType, areaText]
        .filter(Boolean)
        .join(joinSeparator);
};
